import {course_getCourseById_Api, courseSchema,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {CourseContainerContext} from "./CourseContainer";
import {PiCertificate, PiTextSuperscriptBold} from "react-icons/pi";
import {BsArrowLeftCircle, BsDisplayFill, BsGearFill, BsInboxesFill, BsPersonFillAdd} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {getId, getType} from "../../../../apis/model/base";
import {ClassActionTypes} from "../../../AppLocals/Course";
import {useCourseClassForm} from "../../../AppLocals/Course/CourseClass/useCourseClassForm";
import {Avatar, Button} from "antd";
import {FiChevronsRight} from "react-icons/fi";
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import {CourseStudentsSearchBinding} from "../../../AppLocals/Course/CourseClass/CourseStudentForm";
import {CourseEnrollmentsByCourseSearchBinding} from "./CourseEnrollmentsByCourse";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {CourseSubjectList} from "../../../AppLocals/Course/CourseSet/CourseSubjectForm";
import {EditCourseModal} from "../../../AppLocals/Course/CourseSet/CourseSetForm";
import {useCourseApi} from "../../../AppLocals/Course/CourseClass/useCourseApi";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import classNames from "classnames";
import {FaUserGraduate} from "react-icons/fa6";
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";
import {CourseStates} from "../WorkspaceCourse";
import {ItemInformation} from 'components/common/ItemInformation'
import {showDeleteConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {CourseGraduationDashboard} from "./CourseGraduationDashboard";
import {AiFillDelete} from "react-icons/ai";
import {useSelectEntities} from "../../../../redux/entities/useSelectEntities";

// --- Cấu trúc Menu Cấp 2 (Chi tiết Khóa học) ---
const COURSE_TABS = [
    {key: 'overview', name: 'overview', icon: <BsDisplayFill size={18}/>},
    {key: 'classes', name: 'classes', icon: <ClassroomSvg size={14}/>},
    {key: 'enrollment', name: 'enrollment', icon: <BsPersonFillAdd size={18}/>},
    {key: 'student', name: 'students', icon: <FaUserGraduate size={15}/>},
    {key: 'subject', name: 'subjects', icon: <PiTextSuperscriptBold size={18}/>},
    {key: 'graduation', name: 'assessment', icon: <PiCertificate size={16}/>},
    {key: 'settings', name: 'course settings', icon: <BsGearFill size={16}/>},
    {key: 'destroy', name: 'delete content', icon: <AiFillDelete size={16}/>},
];


const CourseDetail = ({}) => {
    const t = useTranslate();
    const courseDetailTab = useRouteSearchParam("course-detail-tab") || "overview"
    const [activeTab, setActiveTab] = useState(courseDetailTab);
    const {isSm, isLg} = useContext(LayoutContext)
    const [selectedCourse, setSelectedCourse] = useState({});
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
        onSelectCourseContainerRoute
    } = useContext(CourseContainerContext);


    const {handleAsyncAction: getCourseById} = useAsyncAction({
        apiInfo: course_getCourseById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data', []);
            setSelectedCourse(dataItem);
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const {
        modal,
        handleAction,
        onCancel,
        refreshKey
    } = useCourseClassForm({course: selectedCourse})

    const {
        onCourseUpdate, onCourseDelete,
        onCourseCreate, onCourseDuplicate,
        grantCertificateToStudentInCourse, revokeCertificateFromStudentInCourse, issueThirdCertificateIfEligible,
        confirmCourseDelete,
        confirmGrantCertificateToStudentInCourse, confirmRevokeCertificateFromStudentInCourse
    } = useCourseApi({owner_id: selectedCourse?.owner?.id, owner_type: getType(selectedCourse?.owner)})


    useEffect(() => {
        if (current_course_id) {
            getCourseById({}, {id: current_course_id})
        }
    }, [current_course_id])

    const currentCourse = useSelectEntities(
        getId(selectedCourse),
        courseSchema,
        selectedCourse
    )

    const courseClasses = _.get(currentCourse, 'course_classes', []);

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderCourseContent = useMemo(() => {
            switch (activeTab) {
                case 'overview':
                    return (
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col gap-2">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('course information')}
                                </h3>
                                <div className="ml-2 flex flex-col gap-1">
                                    {(currentCourse?.academic_field !== null || currentCourse?.academic_year !== 0) && (
                                        <div
                                            style={{
                                                padding: '3px 8px',
                                                fontSize: 11,
                                                borderRadius: 999,
                                                wordBreak: 'break-all'
                                            }}
                                            className="w-fit border border-primary-400 font-medium text-primary-700 italic leading-tight min-w-0 max-lines-1">
                                            {currentCourse?.academic_field}
                                            {(currentCourse?.academic_year !== 0 && currentCourse?.academic_field !== null) ?
                                                ` - ${currentCourse?.academic_year}` :
                                                currentCourse?.academic_year !== 0 ? currentCourse?.academic_year : ''}
                                        </div>
                                    )}
                                    <ItemInformation
                                        showIcon={true}
                                        label="status"
                                        value={
                                            <span
                                                style={{padding: '2px 8px', borderRadius: 999}}
                                                className={classNames(
                                                    `font-medium text-xs italic`,
                                                    _.find(CourseStates, {value: currentCourse?.course_state})?.className
                                                )}>
                                        {t(_.find(CourseStates, {value: currentCourse?.course_state})?.label)}
                                    </span>
                                        }
                                        className="text-sm"
                                    />
                                    <ItemInformation
                                        showIcon={true}
                                        label="start at"
                                        value={formatSimplifyDate(currentCourse?.time_open, null, "DD MMMM, YYYY")}
                                        className="text-sm"
                                    />
                                    <ItemInformation
                                        showIcon={true}
                                        label="end at"
                                        value={formatSimplifyDate(currentCourse?.time_close, null, "DD MMMM, YYYY")}
                                        className="text-sm"
                                    />

                                    {currentCourse?.last_enrollment_time && (
                                        <ItemInformation
                                            showIcon={true}
                                            label="deadline"
                                            value={formatSimplifyDate(currentCourse?.last_enrollment_time, null, "DD MMMM, YYYY")}
                                            className="text-sm"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col gap-2">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('insights')}
                                </h3>
                                <div className="ml-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div
                                        style={{
                                            border: '1px solid rgba(253, 186, 116, 1)',
                                            boxShadow: '0 2px 4px 0px rgba(254, 215, 170, 1)',
                                        }}
                                        className="px-4 py-3 flex items-center justify-between border border-color-100 background shadow-md rounded-xl">
                                        <div className="flex flex-col flex-1">
                                            <p className="font-medium text-sm text-color-300 tracking-wider">{t('number of classes')}</p>
                                            <p className="mt-1 text-2xl font-bold text-gray-900 tracking-wide">{courseClasses?.length}</p>
                                        </div>
                                        <Avatar
                                            size={40}
                                            className="flex flex-center bg-orange-100"
                                            icon={<ClassroomSvg size={20} className="text-orange-500"/>}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            border: '1px solid rgba(106, 187, 141, 1)',
                                            boxShadow: '0 2px 4px 0px rgba(198, 246, 213, 1)',
                                        }}
                                        className="px-4 py-3 flex items-center justify-between border border-color-100 background shadow-md rounded-xl">
                                        <div className="flex flex-col flex-1">
                                            <p className="font-medium text-sm text-color-300 tracking-wider">{t('total students')}</p>
                                            <p className="mt-1 text-2xl font-bold text-gray-900 tracking-wide">{currentCourse?.student_count}</p>
                                        </div>
                                        <Avatar
                                            size={40}
                                            className="flex flex-center bg-green-100"
                                            icon={<FaUserGraduate size={20} className="text-green-500"/>}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                style={{padding: '0.5rem'}}
                                className="mt-4 w-70 mx-auto sm:w-auto bg-indigo-500 hover:bg-indigo-600 font-medium text-white shadow-md rounded-lg hover:scale-xs transition"
                                onClick={() => setActiveTab('classes')}>{t("view classes")}
                            </button>
                        </div>
                    );
                case 'classes':
                    return (
                        <div className="flex flex-col">
                            <div className="flex flex-col mb-4">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {`${t("view classes")} (${courseClasses.length})`}
                                </h3>
                                <div className="flex justify-end">
                                    <Button
                                        color="primary" variant="solid"
                                        className="px-3 flex flex-center font-medium rounded-lg shadow-md transition"
                                        onClick={() => {
                                            handleAction(ClassActionTypes.CLASS_CREATE)
                                        }}>
                                        {t('create class')}
                                    </Button>
                                </div>
                            </div>

                            <div className="flex flex-col gap-4">
                                {courseClasses.length > 0 ? (
                                    <div
                                        className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                                        {courseClasses.map(cls => (
                                            <div key={cls.id} className="p-4 flex flex-col flex-1 list-item">
                                                <h4
                                                    onClick={() => {
                                                        onSelectCourseContainerRoute({current_course_class_id: cls.id})
                                                    }}
                                                    className="font-bold text-base text-color-000 hover:text-primary tracking-wide cursor-pointer">
                                                    {cls.title}
                                                </h4>
                                                <div className="text-xs space-x-1 tracking-wider">
                                                    <span className="text-color-400">
                                                        {t('course class idcode')}:
                                                    </span>
                                                    <span className="font-mono font-semibold text-blue-600">
                                                        {`#${cls?.course_class_idcode}`}
                                                    </span>
                                                </div>
                                                <div className="my-2 border-b border-color-50"/>
                                                <ItemInformation
                                                    showIcon={true}
                                                    label="teacher"
                                                    value={_.get(cls, 'coordinators.0.teacher.fullname')}
                                                    className="italic"
                                                />
                                                {cls?.student_count ? (
                                                    <ItemInformation
                                                        showIcon={true}
                                                        label="student"
                                                        value={`${cls?.student_count} ${t('student')}`}
                                                        className="italic"
                                                    />
                                                ) : null}
                                                <div className="flex justify-end">
                                                    <button
                                                        onClick={() => {
                                                            onSelectCourseContainerRoute({current_course_class_id: cls.id})
                                                        }}
                                                        className="text-color-400 hover:text-indigo-600">
                                                        {t('view detail')} <FiChevronsRight size={13}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div
                                        className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                        <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                                        <span className="text-center text-sm text-color-300 tracking-wider italic">
                                            {t('no classes created yet')}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                case 'enrollment':
                    return (
                        <div className="flex flex-col">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("manage enrollment applications")}
                            </h3>
                            {!!currentCourse?.id && (
                                <CourseEnrollmentsByCourseSearchBinding
                                    owner_id={getId(currentCourse?.owner)}
                                    owner_type={getType(currentCourse?.owner)}
                                    course_id={currentCourse?.id}
                                    subjects={_.get(currentCourse, 'subjects', [])}
                                    showHeader={false}
                                />
                            )}
                            <div className="mt-6 p-3 background-100 rounded-lg text-sm">
                                <span className="font-bold text-color-000">
                                    {`${t('note')}: `}
                                </span>
                                <span className="text-color-200 italic tracking-wider">
                                    {t("a student can belong to multiple classes within this course")}
                                </span>
                            </div>
                        </div>
                    );
                case 'student':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {`${t("student management")} (${currentCourse.student_count})`}
                            </h3>

                            {!!currentCourse?.id && (
                                <CourseStudentsSearchBinding
                                    owner_id={getId(currentCourse?.owner)}
                                    owner_type={getType(currentCourse?.owner)}
                                    item={currentCourse}
                                    showHeader={false}
                                />
                            )}
                            <div className="mt-6 p-3 background-100 rounded-lg text-sm">
                            <span className="font-bold text-color-000">
                                {`${t('note')}: `}
                            </span>
                                <span className="text-color-200 italic tracking-wider">
                                {t("a student can belong to multiple classes within this course")}
                            </span>
                            </div>
                        </div>
                    );
                case 'subject':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {`${t("subjects")} (${_.get(currentCourse, 'subjects', []).length})`}
                            </h3>
                            <div className="space-y-4">
                                {!!currentCourse?.id && bindingSearch({
                                    onCancel,
                                    owner_id: getId(currentCourse?.owner),
                                    owner_type: getType(currentCourse?.owner),
                                    item: currentCourse,
                                })(CourseSubjectList)}
                            </div>
                        </div>
                    );
                case 'graduation':
                    return !!currentCourse?.id && (
                        <CourseGraduationDashboard
                            course_id={currentCourse.id}
                            course={currentCourse}
                            can_edit={!!currentCourse.edit}
                        />
                    );
                case 'settings':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("course settings")}
                            </h3>
                            <div className="p-3 background border border-color-50 shadow-md rounded-lg">
                                <ul style={{paddingLeft: 20, listStyleType: 'disc'}} className="flex flex-col gap-1">
                                    <li className="text-color-300 tracking-wider">
                                        {t("manage name description and official start end dates")}
                                    </li>
                                    <li className="text-color-300 tracking-wider">
                                        {t("configure certificate template awarded upon course completion")}
                                    </li>
                                </ul>
                            </div>

                            <div className="mt-3">
                                {
                                    !!currentCourse?.id && (
                                        <EditCourseModal
                                            initialValues={currentCourse}
                                            onCancel={onCancel}
                                            onSubmit={(values) => {
                                                onCourseUpdate(values, {id: currentCourse?.id})
                                            }}
                                        />
                                    )
                                }
                            </div>

                        </div>
                    );
                case 'destroy':
                    return (
                        <div className="flex flex-col">

                            <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                                <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t("delete course")}
                                </h3>
                                <p className="text-color-300 tracking-wider mb-4">
                                    {t("this action will permanently delete the course and all related data")}
                                </p>
                                <div className="text-right">
                                    <button
                                        onClick={() => {
                                            showDeleteConfirmDialog({
                                                translate: t,
                                                title: 'delete this',
                                                message: 'are you sure you want to delete this',
                                                onOk: () => {
                                                    onCourseDelete({}, {id: currentCourse?.id})
                                                },
                                            })
                                        }}
                                        className="px-6 py-2 bg-primary-600 hover:bg-primary-700 font-medium text-sm text-white shadow-md rounded-lg">
                                        {t("delete course permanently")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                default:
                    return null;
            }
        },
        [activeTab, refreshKey, current_course_id, currentCourse?.id, ]);

    if (!!!current_course_id) return null

    return (
        <div className="w-full min-h-screen">
            {/* Header Khóa học */}
            <div className="mb-6 p-4 background shadow-lg rounded-b-xl stickyTop1 z-12">
                <button
                    onClick={() => {
                        onSelectCourseContainerRoute({current_course_id: '', current_course_class_id: ''})
                    }}
                    className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {t("back to course list")}
                </button>
                <Link to={getLinkToDetail(currentCourse)} className="text-primary-800 no-underline">
                    <h1 className="text-2xl font-bold tracking-wide space-x-1">
                        <span className="text-gray-500 text-underline">{t("course")}:</span>
                        <span>{currentCourse.title}</span>
                    </h1>
                </Link>
                <div className="mt-1 flex items-center gap-1 text-sm tracking-wide">
                    <span className="text-color-400 italic">
                        {`${t("start")}: `}
                    </span>
                    <span className="font-medium text-color-000 tracking-wide">
                        {formatSimplifyDate(currentCourse.time_open, null, 'DD MMMM, YYYY')}
                    </span>
                </div>
            </div>

            {/* Navigation Tabs Cấp 2 */}
            <TabNavigation
                tabs={COURSE_TABS}
                activeTab={activeTab}
                className="mt-6 border-color-300"
                style={{top: 'calc(3.5 * var(--header-height))', zIndex: 12}}
                onTabChange={(value) => {
                    onChangeSearchParams({"course-detail-tab": value})
                    setActiveTab(value)
                }}/>

            {/* Nội dung Tab */}
            <div className="p-3 md:p-6 background rounded-b-xl shadow-lg">
                {renderCourseContent}
            </div>
            {modal}
            <div className="h-16"/>
        </div>
    );
};


export default CourseDetail
